import { useTranslation } from 'react-i18next';
import { InvestmentFormSideOverPageProps } from './types';
import { displayInvestmentType, StandardInvestmentForm } from '../../../Investment';
import { SideOverFooter, ElementsButton, SideOverHeading, SideOverHeaderNew } from '../../components';
import { MDTailwindMinPixelBreakpointWidth } from '../../../util';
import { useWindowSize } from 'react-use';

export function InvestmentFormSideOverPage({
  exit,
  firmID,
  clientID,
  isLoading,
  investmentType,
  allowDocuments,
  useInvestmentFormReturn,
}: InvestmentFormSideOverPageProps) {
  const { width: windowWidth } = useWindowSize();
  const { t: tCommon } = useTranslation('common');
  const { t: tInvestment } = useTranslation('investment');

  return (
    <>

      <SideOverHeaderNew exit={exit} withShadow className="!px-4" exitText={tCommon('cancel')} />
      <div className="md:px-10 px-4">

        <SideOverHeading heading={displayInvestmentType(investmentType, tInvestment)} />
        <StandardInvestmentForm
          firmID={firmID}
          clientID={clientID}
          className="mb-28 md:mb-36"
          useInvestmentFormReturn={useInvestmentFormReturn}
          visibilityOptions={{ hideFileList: !allowDocuments, hideCreateFileInput: !allowDocuments }}
        >
          <SideOverFooter>
            <ElementsButton
              icon="check"
              iconPosition="left"
              isLoading={isLoading}
              label={tCommon('save')}
              size={windowWidth < MDTailwindMinPixelBreakpointWidth ? 'small' : 'large'}
            />
          </SideOverFooter>
        </StandardInvestmentForm>
      </div>
    </>
  );
}
